(function () {
  'use strict';

  angular
      .module('tfc.retailer.ConsumerSampling')
      .controller('ConsumerSamplingCtrl', ConsumerSamplingCtrl)
      .constant('SamplingSegmentMap', {
        'One and Done': {title: 'NON SAMPLERS', imgSrc: 'images/consumer-sampling/non-sample.svg'},
        'Style Samplers': {title: 'STYLE ONLY SAMPLERS', imgSrc: 'images/consumer-sampling/style-sample.svg'},
        'Omni Samplers': {title: 'SIZE & STYLE SAMPLERS', imgSrc: 'images/consumer-sampling/size-style-sample.svg'},
        'Size Samplers': {title: 'SIZE ONLY SAMPLERS', imgSrc: 'images/consumer-sampling/size-sample.svg'}
  });

  // @ngInject
  function ConsumerSamplingCtrl($state, CookieJar, selectedBrandKey, userBrands, samplingSummary,
                                samplingGender, samplingAgeRange, ConsumerSamplingReport, aggregationLogDetails) {
    var vm = this;

    vm.brands = _.isArray(userBrands) ? userBrands : [];
    vm.selectedBrand = _.find(vm.brands, {key: selectedBrandKey });
    vm.aggregationDetails = aggregationLogDetails;
    vm.samplingSummary = samplingSummary;
    vm.samplingAgeRangeArr = samplingAgeRange;
    vm.samplingGender = samplingGender;

    vm.getLabel =  function(value){
      return _.isNumber(value) ? (value * 100).toFixed(1) : "";
    };

    vm.appliedSamplingClass = function (sampling) {
      if(sampling.showBenchmark){
        return 'text-right display-flex';
      } else {
        if(!sampling.showBenchmark && !sampling.isBrandConsumerDetailsAvailable){
         return 'text-center display-flex';
        } else return '';
      }
    }

    vm.selectedBrandReload =  function(selectedBrand){
      vm.selectedBrand = selectedBrand;
      vm.reload(true);
    };

    vm.reload = function(resetBrand){
      CookieJar.set({ name: 'tfc-insight-selected-brand', value : _.toString(vm.selectedBrand.key)});
      if(resetBrand){
        $state.go('.',{ brandKey : vm.selectedBrand.key });
      }
    };

    vm.downloadReport = function(){
      ConsumerSamplingReport.downloadReport(vm.selectedBrand.key);
    };

    vm.isBrandSampling = function(){
      return vm.samplingSummary.length && _.some(samplingSummary,'isBrandConsumerDetailsAvailable');
    };

    vm.getSamplingSegmentDetails = function (samplingData, segment) {
      return _.find(samplingData, function (data) {return data.samplingSegment === segment});
    }

  }

})();